import React from 'react'
import { ICountry, COUNTRIES_INFO } from './countriesInfo'
import {
  DEV_RC_VALIDATION_OPTIONS,
  IValidationOption,
  PROD_VALIDATION_OPTIONS,
  RU_DEV_RC_VALIDATION_OPTIONS,
  RU_PROD_VALIDATION_OPTIONS,
} from './validationOptions'
import { escapeRegExp, getDigits } from '../../utils/common'
import RuIcon from './assets/RuIcon'
import WorldIcon from './assets/WorldIcon'
import KzIcon from './assets/KzIcon'
import UzIcon from './assets/UzIcon'
import { Languages } from '../../interfaces/common'
import { DeployTypes } from '../../emun/DeployTypes'
import { CountryCodes } from '../../emun/CountryCodes'

const DEFAULT_PHONE_MASK = '+# ### #######'

export const getDeployEnvValidationOptions = (deployEnv: DeployTypes) =>
  deployEnv === DeployTypes.Production ? PROD_VALIDATION_OPTIONS : DEV_RC_VALIDATION_OPTIONS

export const getLocaleDeployEnvValidationOptions = (deployEnv: DeployTypes, locale: Languages) => {
  if (locale === Languages.RU) {
    return deployEnv === DeployTypes.Production ? RU_PROD_VALIDATION_OPTIONS : RU_DEV_RC_VALIDATION_OPTIONS
  }

  return getDeployEnvValidationOptions(deployEnv)
}

export function getValidationOptions(value: string, deployEnv: DeployTypes): IValidationOption | undefined {
  const formattedValue = getDigits(value)
  const validationOptions = getDeployEnvValidationOptions(deployEnv)

  return validationOptions.find((option) => {
    const digitMask = getDigits(option.mask)
    const regExp = new RegExp(`^${digitMask}`)

    return regExp.test(formattedValue)
  }, [])
}

export function getCountry(validationOption: IValidationOption | undefined): ICountry | null {
  if (validationOption) {
    const countryCode = validationOption?.countryCode
    const country = COUNTRIES_INFO.find((item) => item.countryCode === countryCode)

    return country ?? null
  }

  return null
}

export function getMask(validationOption: IValidationOption | undefined): string {
  const mask = validationOption?.mask ?? DEFAULT_PHONE_MASK

  return mask.replace(/[\#0-9]/g, '0')
}

export function formatPhoneValue(value: string, validationOption: IValidationOption | undefined): string {
  const mask = validationOption?.mask ?? DEFAULT_PHONE_MASK

  const digitValue = value.replace(/[^\d]/gi, '')
  const digitList = digitValue.split('')
  let formattedValue = mask.replace(/\d/gi, '#')

  digitList.forEach((digit) => {
    formattedValue = formattedValue.replace(/#/, digit)
  })

  formattedValue = formattedValue.replace(/#/gi, '')
  formattedValue = formattedValue.trim()

  return formattedValue
}

export function checkPhoneValid(value: string, deployEnv: DeployTypes, locale: Languages): boolean {
  const validationOptions = getLocaleDeployEnvValidationOptions(deployEnv, locale)

  for (let i = 0; i < validationOptions.length; i += 1) {
    const { mask } = validationOptions[i]
    const escapedMask = escapeRegExp(mask)
    const formattedMask = escapedMask.replace(/#/gi, '\\d')
    const regExp = new RegExp(`^${formattedMask}$`)
    const isMatch = regExp.test(value)

    if (isMatch) {
      return true
    }
  }

  return false
}

export const preparePhone = (value: string, locale: Languages) =>
  locale === Languages.RU ? value.replace(/^8/, '+7') : value

export const getCountryIcon = (country: ICountry | null) => {
  if (country) {
    if (country.countryCode === CountryCodes.Russia) {
      return <RuIcon />
    }

    if (country.countryCode === CountryCodes.Kazakhstan) {
      return <KzIcon />
    }

    if (country.countryCode === CountryCodes.Uzbekistan) {
      return <UzIcon />
    }
  }

  return <WorldIcon />
}
